if (!customElements.get('cly-cart-discount')) {
  customElements.define('cly-cart-discount', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('form').addEventListener('submit', event => this.apply(event));
    }
    async apply(event) {
      event.preventDefault();
      const drawer = this.closest('cart-drawer');
      const input = this.querySelector('input');
      const code = input.value.trim();
      if (!code || drawer.dataset.clyAdding === 'true' || drawer.querySelector('.cart__items--disabled')) return;
      const controls = [...drawer.querySelectorAll('input,select,button')].map(el => [el, el.disabled]);
      const message = this.querySelector('[role="status"]');
      message.hidden = true;
      drawer.dataset.clyAdding = 'true';
      controls.forEach(([el]) => el.disabled = true);
      let updated = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error();
        const cart = await cartResponse.json();
        const codes = (cart.discount_codes || []).map(item => item.code).filter(Boolean);
        if (!codes.some(value => value.toLowerCase() === code.toLowerCase())) codes.push(code);
        const response = await fetch(root + 'cart/update.js', {
          method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({discount:codes.join(','), sections:['cart-drawer','cart-icon-bubble'], sections_url:window.location.pathname})
        });
        let result = await response.json();
        if (!response.ok || result.errors || result.status) throw new Error();
        updated = true;
        const applications = [...(result.cart_level_discount_applications || []), ...(result.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))];
        const match = (result.discount_codes || []).find(item => item.code.toLowerCase() === code.toLowerCase());
        const applied = match?.applicable === true || applications.some(a => a?.type === 'discount_code' && a.title?.toLowerCase() === code.toLowerCase());
        const i18n = window.CarmelynaTranslations || {};
        const text = applied ? i18n.discountApplied : match?.applicable === false ? i18n.discountNotApplicable : i18n.discountSubmitted;
        if (window.CarmelynaGift) result = await window.CarmelynaGift.afterMutation(result);
        if (!result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) throw new Error();
        drawer.renderContents(result);
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'cart-items', cartData:result});
        const fresh = drawer.querySelector('cly-cart-discount');
        fresh.querySelector('input').value = code;
        const status = fresh.querySelector('[role="status"]');
        status.textContent = text;
        status.hidden = false;
        status.focus();
      } catch (error) {
        if (updated) { window.location.assign(window.routes.cart_url); return; }
        message.textContent = (window.CarmelynaTranslations || {}).discountCheckFailed;
        message.hidden = false;
      } finally {
        delete drawer.dataset.clyAdding;
        controls.forEach(([el, disabled]) => { if (el.isConnected) el.disabled = disabled; });
      }
    }
  });
}